import { z } from "zod";
import { smsSendReferencesZodObject } from "./sms-send-references";

const smsSendRequestZodObject = z.discriminatedUnion("smsProviderName", [
    z.object({
        _id: z.string(),
        _createdAt: z.string().datetime(),
        _type: z.literal("SMS_SEND_REQUEST"),
        smsProviderName: z.enum(["46elks", "test"]),
        smsProviderSettings: z.never().optional(),
        senderId: z.string().optional(),
        recipient: z.string().min(1),
        message: z.string().min(1),
        category: z.string().min(1),
        references: smsSendReferencesZodObject,
        callbackUrl: z.string().url(),
    }),
    z.object({
        _id: z.string(),
        _createdAt: z.string().datetime(),
        _type: z.literal("SMS_SEND_REQUEST"),
        smsProviderName: z.literal("twilio"),
        smsProviderSettings: z.object({
            // If true we will allow twilio to do a risk check on the message
            riskCheck: z.boolean(),
        }),
        senderId: z.string().optional(),
        recipient: z.string().min(1),
        message: z.string().min(1),
        category: z.literal("login").or(z.string().min(1)),
        references: smsSendReferencesZodObject,
        callbackUrl: z.string().url(),
    }),
]);

type SmsSendRequest = z.infer<typeof smsSendRequestZodObject>;

export { smsSendRequestZodObject };
export type { SmsSendRequest };
